import { ClientResources, SampleUpdateRequest, SampleSex } from "@app/api2/api";
import * as yup from "yup";

export type SampleUpdateRequestWithDobMode = SampleUpdateRequest & {
    dobMode?: 'date' | 'age';
};

export const SampleEditSchema: (t: ClientResources) => yup.SchemaOf<SampleUpdateRequestWithDobMode> = (t: ClientResources) => yup.object().shape({
    kitId: yup.number().required().label(t.common.kit || 'Kit'),
    dateOfBirth: yup.date().optional().nullable().label(t.sample.dateOfBirth || 'Date of Birth') as any,
    sex: yup.mixed<SampleSex>().optional().nullable().label(t.brutus.sex || 'Sex'),
    name: yup.string().required().label(t.sample.name || 'Name'),
    labId: yup.number().optional(),
    sampleId: yup.number().optional(),
    birthYear: yup.number().optional().nullable().label(t.sample.birthYear || 'Birth Year'),
    birthDay: yup.number().optional().nullable().label(t.sample.birthDay || 'Birth Day'),
    birthMonth: yup.number().optional().nullable().label(t.sample.birthMonth || 'Birth Month'),
    ageMonths: yup.number().optional().nullable().label(t.sample.ageMonths || 'Age Months'),
    ageYears: yup.number().optional().nullable().label(t.sample.ageYears || 'Age Years'),
    dobMode: yup.mixed<'date' | 'age'>().optional(),
});